import { Component, Input, OnInit } from '@angular/core';
import { PurchaseFlowService } from '../../../services/purchase-flow.service';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '../../../common/base/base.component';
import { AuthService } from '../../../services/auth.service';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss'],
})
export class PreviewComponent extends BaseComponent implements OnInit {
  @Input() flowInfo: any;

  public publicId: string | undefined;

  constructor(
    private purchaseFlowService: PurchaseFlowService,
    private authService: AuthService
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.flowInfo) {
      return;
    }
    combineLatest([
      this.purchaseFlowService.stepChange$,
      this.authService.publicIdChange$,
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([stepChange, publicId]) => {
        this.flowInfo = { croppedImage: stepChange?.croppedImage as string };
        this.publicId = publicId;
      });
  }
}
